import { AfterViewInit, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ScriptLoaderService } from './services/script-loader.service';
import { ScrollControlService } from './services/scroll-control.service';

declare var $;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  title = 'IPB-Site';

  constructor(
      private scriptLoader: ScriptLoaderService,
      private scroll: ScrollControlService
  ) {
  }
  
  ngAfterViewInit() {



    this.scriptLoader.load(
        "vendor/modernizr-3.5.0.min",
        "vendor/jquery-1.12.4.min",
        "popper.min",
        "bootstrap.min",
        "jquery.slicknav.min",
        "owl.carousel.min",
        "slick.min",
        "gijgo.min",
        "wow.min",
        "animated.headline",
        "jquery.magnific-popup",
        "jquery.scrollUp.min",
        "jquery.nice-select.min",
        "jquery.sticky",
        "waypoints",
        "jquery.counterup.min",
        "contact",
        "jquery.form",
        "jquery.validate.min",
        "mail-script",
        "jquery.ajaxchimp.min",
        "plugins",
        "start",
    ).then(data => {
        console.log('script loaded ', data);
        
        this.scroll.loaded = true;
        
        $('ul.slicknav_nav li').click(() => { $('ul#navigation').slicknav('close'); });
    }).catch(error => console.log(error));
  }
}
